var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.5C2.5 7.26614 6.76614 3 12 3C17.2339 3 21.5 7.26614 21.5 12.5C21.5 17.7339 17.2339 22 12 22C6.76614 22 2.5 17.7339 2.5 12.5ZM13.25 16.5V13.75H16C16.6861 13.75 17.25 13.1861 17.25 12.5C17.25 11.8139 16.6861 11.25 16 11.25H13.25V8.5C13.25 7.81386 12.6861 7.25 12 7.25C11.3139 7.25 10.75 7.81386 10.75 8.5V11.25H8C7.31386 11.25 6.75 11.8139 6.75 12.5C6.75 13.1861 7.31386 13.75 8 13.75H10.75V16.5C10.75 17.1861 11.3139 17.75 12 17.75C12.6861 17.75 13.25 17.1861 13.25 16.5Z",
    fill: "#F08437",
    stroke: "#F08437"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.27716b1bf51e885f1829916819b852cc.svg";
export { ForwardRef as ReactComponent };